import { useAuthContext } from 'src/auth/hooks';
import { useTenantConfig } from 'src/context/tenant';
import { isAppOnlyUser } from 'src/utils/roles';

/**
 * Whether the signed-in user belongs on the app-download page (paths.volunteers.root) and
 * nowhere else in the web portal — see isAppOnlyUser in src/utils/roles.js. Read from the
 * memberships sign-in admitted them on, so it is known immediately, without waiting for the org
 * context. Legislative tenants have no volunteers of this kind: sign-in still refuses them there.
 */
export const useIsAppOnlyUser = () => {
  const { user } = useAuthContext();
  const { isLegislative } = useTenantConfig();
  const globalRole = user?.users_user_roles?.[0]?.user_roles_roles?.code;

  return !isLegislative && isAppOnlyUser(globalRole, user?.users_user_organizations ?? []);
};
